const maritalStatuses = [
  'Married',
  'Widowed',
  'Divorced or Separated',
  'Single',
];

export default maritalStatuses